'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _templateData = require('redux/modules/templateData');

var templateActions = _interopRequireWildcard(_templateData);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _reactColor = require('react-color');

require('./ColorPicker.css');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./ColorPicker.scss');
var ColorPicker = (_dec = (0, _reactRedux.connect)(function (state) {
  return {};
}, {
  updatePrimaryColor: templateActions.updatePrimaryColor,
  updateSecondaryColor: templateActions.updateSecondaryColor
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ColorPicker, _Component);

  function ColorPicker() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ColorPicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ColorPicker.__proto__ || (0, _getPrototypeOf2.default)(ColorPicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      displayColorPicker: false,
      color: _this.props.activeColor
    }, _this.handleClick = function () {
      _this.setState({ displayColorPicker: !_this.state.displayColorPicker });
    }, _this.handleClose = function () {
      _this.setState({ displayColorPicker: false });
    }, _this.handleChange = function (color) {
      _this.setState({ color: color.hex });
      if (_this.props.isPrimaryColor) {
        _this.props.updatePrimaryColor(color.hex);
        var elements = document.getElementsByClassName('primaryColor');
        for (var i = 0; i < elements.length; i++) {
          elements[i].style.color = color.hex;
        }
      } else {
        _this.props.updateSecondaryColor(color.hex);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ColorPicker, [{
    key: 'render',
    value: function render() {

      var styles = (0, _reactcss2.default)({
        'default': {
          color: {
            width: '36px',
            height: '14px',
            borderRadius: '2px',
            background: '' + this.state.color
          },
          swatch: {
            padding: '2px',
            background: '#fff',
            borderRadius: '1px',
            boxShadow: '0 0 0 1px rgba(0,0,0,1)',
            display: 'inline-block',
            cursor: 'pointer'
          },
          popover: {
            position: 'absolute',
            zIndex: '2',
            left: '-84px'
          },
          cover: {
            position: 'fixed',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px'
          }
        }
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: styles.swatch, onClick: this.handleClick },
          _react2.default.createElement('div', { style: styles.color })
        ),
        this.state.displayColorPicker && _react2.default.createElement(
          'div',
          { style: styles.popover },
          _react2.default.createElement('div', { style: styles.cover, onClick: this.handleClose }),
          _react2.default.createElement(_reactColor.SketchPicker, { color: this.state.color, onChange: this.handleChange })
        )
      );
    }
  }]);
  return ColorPicker;
}(_react.Component)) || _class);
exports.default = ColorPicker;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ColorPicker/ColorPicker.js
// module id = 1734
// module chunks = 0